import { Fragment, useEffect, useState } from "react";
import { Breadcrumb, Button, FloatingLabel, Form, Modal } from "react-bootstrap";
import AsyncSelect from 'react-select/async';
import { getData } from "../../../api/ApiRest";
import { FaSearch } from "react-icons/fa";
import LoadingComponent from "../../../widgets/LoadingComponent";
import { formatNumber } from "../../../widgets/FormatNumber";
import { formatDateddMMMyyyy } from "../../../widgets/DateTime";
import { FaEye, FaMinus, FaPlus } from "react-icons/fa6";
import { Grid, Paper, Table, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

function Cartera() {
    const [loading, setLoading] = useState(false);
    const [dataBuscar, setDataBuscar] = useState({});

    const [cartera, setCartera] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [visualizarRecibos, setVisualizarRecibos] = useState({
        ModalVisible: false, Facturaid: '', Documento: '', Prefijo: '', Numero: ''
    });
    const [recibos, setRecibos] = useState([]);
    const [dataGlobal, setDataGlobal] = useState({});
    const [infoCliente, setInfoClientes] = useState({
        CantidadClientes: 0, CantidadGenerados: 0
    });

    const navigate = useNavigate();

    useEffect(() => {
        setDataBuscar({ ...dataBuscar, FechaCorte: new Date().toISOString().split('T')[0] })
    }, [])

    const buscarCartera = (event) => {
        event.preventDefault();
        setLoading(true);

        getData('api/Configuracion/UtilityPublic/buscarCartera', {
            FechaCorte: dataBuscar.FechaCorte,
            Cliente: dataBuscar.Cliente || '',
            Prefijo: dataBuscar.Prefijo || '',
            Numero: dataBuscar.Numero || ''
        }).then(response => {
            setCartera(response.cartera);
            setDataGlobal(response.objectCarteraAgrupado);

            visualizarPendientes();

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const companieSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/Company/Select2Company',
            { param: Param }, false).then(response => {
                return response.companies;
            }, error => {
                return [];
            })
    }

    ///Función para visualizar los recibos realizado a una factura de venta
    const visualizarDocumentos = (companyplanid) => {
        getData('api/Configuracion/Company/GetDocumentosPlan', { companyplanid: companyplanid }).then(response => {
            setRecibos(response.documentos);
        }, error => {
            console.log(error);
        })
    }

    ///Función para visualizar todos aquellos clientes que están pendientes x generar facturas
    const visualizarPendientes = () => {
        getData('api/Configuracion/Reporte/ClientesPendientes').then(response => {
            setInfoClientes({
                CantidadClientes: response.cantidadClientes,
                CantidadGenerados: response.cantidadGenerados
            });
        }, error => {
            console.log(error);
        });
    }

    const toggleMostrarHijos = (id) => {
        setExpandedRows((prev) => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    };

    ///Función para totalizar los totales de manera global
    const totalGlobal = (tipo = '') => {
        let total = 0;

        recibos.map((item, index) => {
            total += item[tipo];
        })

        return total;
    }

    const totalCartera = (tipo = '') => {
        let total = 0;

        cartera.filter(x => x.prefijo === visualizarRecibos.Prefijo && x.numero === visualizarRecibos.Numero).map((item, index) => {
            total = item[tipo];
        })

        return total;
    }

    const handleClientes = () => {
        navigate('/Home/ReportePendientes');
    }

    const visualizarClientesVinculados = () => {
        navigate('/Home/ReporteClientesVinculados');
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item style={{ fontSize: 14 }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontSize: 14 }} active={true}>Cartera</Breadcrumb.Item>
        </Breadcrumb>

        {<LoadingComponent Loading={loading} />}

        <div className="row" style={{ marginBottom: '5px' }}>
            <div className="col-md-2">
                <button className="btn btn-sm btn-warning" title="Visualizar clientes vinculados" onClick={() => visualizarClientesVinculados()}>
                    <FaEye />
                </button>
            </div>
        </div>

        <Form onSubmit={buscarCartera}>
            <div className="row">
                <div className="col-md-2">
                    <FloatingLabel
                        controlId="Fecha"
                        label="Fecha corte"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="date"
                            autoComplete='off'
                            placeholder="Fecha"
                            value={dataBuscar.FechaCorte}
                            onChange={value => setDataBuscar({ ...dataBuscar, FechaCorte: value.target.value })}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>
                <div className='col-md-5'>
                    <AsyncSelect cacheOptions defaultOptions
                        menuPosition='fixed'
                        noOptionsMessage={() => 'Escriba para iniciar la busqueda'}
                        placeholder="Cliente"
                        isClearable={true}
                        loadOptions={companieSearchSelect2}
                        onChange={value => {
                            if (value === null)
                                setDataBuscar({ ...dataBuscar, Cliente: '' })
                            else
                                setDataBuscar({ ...dataBuscar, Cliente: value.value })
                        }}
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: 50
                            })
                        }}
                    />
                </div>
                <div className='col-md-2'>
                    <FloatingLabel
                        controlId='Prefijo'
                        label="Prefijo"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="text"
                            placeholder="Prefijo"
                            value={dataBuscar.Prefijo}
                            onChange={value => setDataBuscar({ ...dataBuscar, Prefijo: value.target.value })}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>
                <div className='col-md-2'>
                    <FloatingLabel
                        controlId='Numero'
                        label="Número"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="number"
                            placeholder="Número"
                            value={dataBuscar.Numero}
                            onChange={value => setDataBuscar({ ...dataBuscar, Numero: value.target.value })}
                            min={0}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>
                <div className='col-md-1'>
                    <Button variant='primary' type='submit' size="sm">
                        <FaSearch size={'0.8rem'} />
                    </Button>
                </div>
            </div>
        </Form>

        <div className="row">
            <Grid container spacing={2} padding={1}>
                <Grid item xs={12} md={4}>
                    <TableContainer
                        component={Paper}
                        sx={{
                            borderRadius: 3,
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                            overflow: "hidden",
                            height: 90
                        }}
                    >
                        <Typography
                            sx={{
                                bgcolor: "rgba(34, 75, 106, 1)",
                                color: "white",
                                py: 1,
                                px: 2,
                                fontWeight: "bold",
                            }}
                            style={{ textAlign: 'center', fontSize: 16 }}
                        >
                            Total deben
                        </Typography>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            bgcolor: "rgba(144, 203, 216, 1)",
                                            color: "rgba(34, 75, 106, 1)",
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            display: "flex",
                                            verticalAlign: "middle",
                                            height: 50
                                        }}
                                    >
                                        {formatNumber(dataGlobal.totalDeben || 0)}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                    </TableContainer>
                </Grid>

                <Grid item xs={12} md={4}>
                    <TableContainer
                        component={Paper}
                        sx={{
                            borderRadius: 3,
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                            overflow: "hidden",
                            height: 90
                        }}
                    >
                        <Typography
                            sx={{
                                bgcolor: "rgba(34, 75, 106, 1)",
                                color: "white",
                                py: 1,
                                px: 2,
                                fontWeight: "bold",
                            }}
                            style={{ textAlign: 'center', fontSize: 16 }}
                        >
                            Cant registros
                        </Typography>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            bgcolor: "rgba(144, 203, 216, 1)",
                                            color: "rgba(34, 75, 106, 1)",
                                            fontWeight: "bold",
                                            textAlign: "center",
                                        }}
                                    >
                                        {formatNumber(dataGlobal.cantidadRegistros || 0)}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                    </TableContainer>
                </Grid>

                <Grid item xs={12} md={4}>
                    <TableContainer
                        component={Paper}
                        sx={{
                            borderRadius: 3,
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                            overflow: "hidden",
                            height: 90
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                bgcolor: "rgba(34, 75, 106, 1)",
                                color: "white",
                                py: 1,
                                px: 2,
                                fontWeight: "bold",
                            }}
                            style={{ textAlign: 'center', fontSize: 16 }}
                        >
                            Facturación mensual
                        </Typography>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            bgcolor: "rgba(144, 203, 216, 1)",
                                            color: "rgba(34, 75, 106, 1)",
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => handleClientes()}
                                    >
                                        {formatNumber(infoCliente.CantidadClientes - infoCliente.CantidadGenerados || 0)}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </div>

        <div className="row">
            <div className='table-responsive mt-2'>
                <table className='table table-borderless table-hover'>
                    <thead>
                        <tr>
                            <th className="estilo-encabezado"></th>
                            <th className="estilo-encabezado">#</th>
                            <th className="estilo-encabezado">
                                Nit
                            </th>
                            <th className="estilo-encabezado">
                                Cliente
                            </th>
                            <th className="estilo-encabezado">
                                Fecha ult pago
                            </th>
                            <th className="estilo-encabezado">
                                Saldo
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {cartera.map((item, index) => (
                            <Fragment key={index}>
                                <tr style={{ fontSize: 14 }}>
                                    <td className="text-center">
                                        <Button
                                            style={{
                                                backgroundColor: "#224B6A",
                                                color: "rgba(144, 203, 216, 1)",
                                                fontWeight: "bold",
                                                textAlign: "center",
                                                fontSize: 8
                                            }}
                                            onClick={() => toggleMostrarHijos(item.facturaid)}
                                        >
                                            {expandedRows.includes(item.facturaid) ? <FaMinus /> : <FaPlus />}
                                        </Button>
                                    </td>
                                    <td className="text-center">
                                        {index + 1}
                                    </td>
                                    <td className="text-center">
                                        {item.identification_number}
                                    </td>
                                    <td className="text-center">
                                        {item.cliente}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {formatDateddMMMyyyy(item.fecha_ult_pago) === '31-Dic-1969' ? '' : formatDateddMMMyyyy(item.fecha_ult_pago)}
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                        $ {formatNumber(item.saldofv)}
                                    </td>
                                </tr>

                                {expandedRows.includes(item.facturaid) && cartera.filter(x => x.companyid === item.companyid).map((carteras) => {
                                    return (
                                        <tr key={carteras.facturaid} style={{ fontSize: 14 }}>
                                            <td style={{ backgroundColor: "rgba(144, 203, 216, 1)", fontSize: 14 }}></td>
                                            <td style={{ backgroundColor: "rgba(144, 203, 216, 1)", fontSize: 14 }}></td>
                                            <td style={{ backgroundColor: "rgba(144, 203, 216, 1)", fontSize: 14 }}></td>
                                            <td style={{
                                                textAlign: 'center',
                                                backgroundColor: "rgba(144, 203, 216, 1)",
                                                fontSize: 14,
                                                cursor: 'pointer',
                                                textDecoration: 'underline'
                                            }}
                                                onClick={() => {
                                                    setVisualizarRecibos({
                                                        ModalVisible: true,
                                                        Facturaid: carteras.facturaid,
                                                        Documento: carteras.prefijo + " - " + carteras.numero,
                                                        Prefijo: carteras.prefijo,
                                                        Numero: carteras.numero
                                                    });

                                                    visualizarDocumentos(item.company_planid);
                                                }}>
                                                {carteras.prefijo} - {carteras.numero}
                                            </td>
                                            <td style={{
                                                textAlign: 'center',
                                                backgroundColor: "rgba(144, 203, 216, 1)",
                                                fontSize: 14
                                            }}>
                                                {formatDateddMMMyyyy(carteras.fecha)}
                                            </td>
                                            <td style={{
                                                textAlign: 'right',
                                                backgroundColor: "rgba(144, 203, 216, 1)",
                                                fontSize: 14
                                            }}>
                                                $ {formatNumber(carteras.saldofv)}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>

        <Modal
            show={visualizarRecibos.ModalVisible}
            size="lg"
            onHide={() => {
                setVisualizarRecibos({ ModalVisible: false, Documento: '', Facturaid: '' });

                setRecibos([]);
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Información {visualizarRecibos.Documento}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='table-responsive mt-2'>
                    <table className='table table-borderless table-hover'>
                        <thead>
                            <tr>
                                <th className="estilo-encabezado">#</th>
                                <th className="estilo-encabezado">
                                    Documento
                                </th>
                                <th className="estilo-encabezado">
                                    Fecha
                                </th>
                                <th className="estilo-encabezado">
                                    Valor
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {recibos.map((item, index) => (
                                <tr key={index} style={{ fontSize: 14 }}>
                                    <td style={{ textAlign: 'center' }}>
                                        {index + 1}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {item.prefijo} - {item.numero}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {formatDateddMMMyyyy(item.fecha)}
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                        $ {formatNumber(item.valor)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={3} style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 20 }}>Total</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold', fontSize: 20 }}>
                                    $ {formatNumber(totalGlobal('valor'))}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={3} style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 20 }}>Total fv</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold', fontSize: 20 }}>
                                    $ {formatNumber(totalCartera('total'))}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={3} style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 20 }}>Saldo</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold', fontSize: 20 }}>
                                    $ {formatNumber(totalCartera('saldofv'))}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </Modal.Body>
        </Modal>
    </div>
}

export default Cartera;